module.exports = __webpack_public_path__ + "img/home-slider-audi.415d06d6.png";